import React, { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import AccountSidebar from "../../components/Account/SIdebar";
import { updateUser } from "../../apiCalls/user";

const MyProfile = () => {
  const dispatch = useDispatch();
  const user = useSelector((state) => state.user.currentUser);
  console.log(user, "user det");

  const initialValues = {
    username: user?.username,
    email: user?.email,
    number: user?.number,
    dob: user?.dob,
    address: user.address,
    landmark: user.landmark,
    pinCode: user.pinCode,
    city: user.city,
    state: user.state,
  };

  const [formValues, setFormValues] = useState(initialValues);
  const [formErrors, setFormErrors] = useState({});
  const [isSubmit, setIsSubmit] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormValues({ ...formValues, [name]: value });
  };

  const updateProfile = (e) => {
    e.preventDefault();
    setFormErrors(validate(formValues));
    setIsSubmit(true);
  };

  const handleClick = async () => {
    const userUpdate = {
      username: formValues?.username,
      email: user?.email,
      number: formValues?.number,
      dob: formValues?.dob,
      address: formValues.address,
      landmark: formValues.landmark,
      pinCode: formValues.pinCode,
      city: formValues.city,
      state: formValues.state,
    };
    // console.log(userUpdate, "user upda");
    await updateUser(dispatch, userUpdate, user._id);
  };

  const validate = (values) => {
    // console.log(values, 'values')
    const errors = {};
    const regex = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/i;

    if (
      !/^[a-z A-Z0-9]+$/.test(values.username) ||
      /^[ ]+$/.test(values.username)
    ) {
      errors.username = "Name is not valid";
    }

    if (!values.username) {
      errors.username = "Name is Required";
    }

    //email
    if (!values.email) {
      errors.email = "Mail Required";
    }
    if (!regex.test(values.email) && values.email) {
      errors.email = "Invalid Mail";
    }

    if (!values?.number) {
      errors.number = "Number is Required";
    }

    if (values?.number?.length < 10) {
      errors.number = "10 Digits Required";
    }

    if (values?.number?.length < 10) {
      errors.number = "10 Digits Required";
    }

    if (values?.number?.length === 10 && !/[0-9]/.test(values?.number)) {
      errors.number = "Number is not Valid";
    }

    if (!values.dob) {
      errors.dob = "Date of Birth is Required";
    }

    // if (!values?.state) {
    //   errors.state = "State is Required";
    // }

    if (!values.pinCode) {
      errors.pinCode = "Pin Code is Required";
    }

    if (values.pinCode?.length === 6 && !/[0-9]/.test(values?.pinCode)) {
      errors.pinCode = "Pin Code is not Valid";
    }

    return errors;
  };

  useEffect(() => {
    console.log("i am hitting again baby");
    if (Object.keys(formErrors).length === 0 && isSubmit) {
      console.log("runn");
      handleClick();
    }
  }, [formValues, formErrors]);

  return (
    <>
      <section className="account-section">
        <div className="container">
          <div className="row">
            <div className="col-full">
              <div className="account-data">
                <AccountSidebar />
                <div className="my-profile">
                  <div className="profile-data-form">
                    <div className="form">
                      <div className="form-tab">
                        <div className="input-groups">
                          <div className="background-img">
                            <div className="img-area">
                              <div className="inner-area">
                              <div className="profile-name">
                                <p>{formValues.username?.slice(0, 1)}</p></div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="input-groups mb-1">
                          <div className="input-field">
                            <label>
                              Full Name<span className="text-red">{" "}(can't edit)</span>
                            </label>
                            <input
                              type="text"
                              name="username"
                              value={formValues.username}
                              readOnly={true}
                              onChange={handleChange}
                              placeholder="Enter Full Name"
                            />
                            <span className="error_msg text-red">
                              {formErrors.username}
                            </span>
                          </div>
                          <div className="input-field">
                            <label>Email<span className="text-red">{" "}(can't edit)</span></label>
                            <input
                              type="email"
                              value={formValues.email}
                              readOnly={true}
                              placeholder="Enter Mail"
                            />
                             <span className="error_msg text-red">
                              {formErrors.email}
                            </span>
                          </div>
                        </div>
                        <div className="input-groups mb-1">
                          <div className="input-field">
                            <label>Mobile No.<span className="text-red">{" "}**</span></label>
                            <input
                              type="text"
                              value={formValues.number}
                              onChange={handleChange}
                              name="number"
                              maxLength="10"
                              placeholder="Enter Mobile Number"
                            />
                            <span className="error_msg text-red">
                              {formErrors.number}
                            </span>
                          </div>
                          <div className="input-field">
                            <label>Enter Date of Birth.<span className="text-red">{" "}**</span></label>
                            <input
                              type="date"
                              name="dob"
                              onChange={handleChange}
                              value={formValues.dob}
                              placeholder="Enter Date of Birth"
                            />
                            <span className="error_msg text-red">
                              {formErrors.dob}
                            </span>
                          </div>
                        </div>
                        <div className="input-groups mb-1">
                          <div className="input-field address">
                            <label>Address.</label>
                            <textarea
                              name="address"
                              placeholder="Enter Address"
                              rows="3"
                              onChange={handleChange}
                              value={formValues.address}
                            ></textarea>
                            <span className="error_msg text-red">
                              {formErrors.address}
                            </span>
                          </div>
                        </div>
                        <div className="input-groups mb-1">
                          <div className="input-field landmark">
                            <label>Landmark</label>
                            <input 
                            type="text" 
                            name="landmark"
                            placeholder="Enter Landmark" 
                            onChange={handleChange}
                            value={formValues.landmark}/>
                            <span className="error_msg text-red">
                              {formErrors.landmark}
                            </span>
                          </div>
                          <div className="input-field pincode">
                            <label>Enter Pin Code<span className="text-red">{" "}**</span></label>
                            <input
                              type="text"
                              name="pinCode"
                              maxLength="6"
                              
                              onChange={handleChange}
                              value={formValues.pinCode}
                              placeholder="Enter PinCode"
                            />
                            <span className="error_msg text-red">
                              {formErrors.pinCode}
                            </span>
                          </div>
                        </div>
                        <div className="input-groups mb-1">
                          <div className="input-field city">
                            <label>New Delhi</label>
                            <input 
                              type="text" 
                              name="city"
                              onChange={handleChange}
                              value={formValues.city}
                              placeholder="Enter City" />
                          </div>
                          <div className="input-field state">
                            <label>Select State<span className="text-red">{" "}**</span></label>
                            <select name="state" id="state" onChange={handleChange} value={formValues.state}>
                              <option value="dehi">Delhi</option>
                              <option value="maharastra">Maharashtra</option>
                              <option value="karnataka">karnatka</option>
                            </select>
                            <span className="error_msg text-red">
                              {formErrors.state}
                            </span>
                          </div>
                        </div>
                        <div className="update-btn">
                          <button
                            type="submit"
                            className="btn"
                            onClick={updateProfile}
                          >
                            Update Now
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default MyProfile;
